import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import { propTypes as ReduxFormPropTypes } from "redux-form";
import { withTrack, withTrackProps } from "@dpdgroupuk/react-event-tracker";
import { Section } from "@dpdgroupuk/mydpd-ui";

import { CHANGE_COLLECTION_DATE_COMPONENT } from "../../constants/analytics";
import { onChangeCollectionDateSubmit } from "./actions";
import EditPanel from "./components/EditPanel";
import DayPickerWithInstruction from "./components/DayPickerWithInstruction";
import { collectEditValidators } from "../../models/validators";
import { hadleInputFocus, loadActionDates, withCollectionEdit } from "./hocs";
import { PLEASE_CHOOSE_A_DATE_BELOW } from "../../constants/strings";

const ChangeCollectionDate = ({
  onBackClick,
  handleSubmit,
  onSubmit,
  error,
  ...rest
}) => {
  return (
    <Section title="Change Collection Date">
      <EditPanel
        title={"Please collect the parcel on the following date"}
        onBackClick={onBackClick}
        onSubmit={handleSubmit(onSubmit)}
        error={error}
      >
        <DayPickerWithInstruction
          {...rest}
          title={PLEASE_CHOOSE_A_DATE_BELOW}
          defaultHeaderDate={rest.collection.collectionDate}
        />
      </EditPanel>
    </Section>
  );
};

ChangeCollectionDate.defaultProps = {
  onBackClick: () => null,
  onSubmit: () => null,
};

ChangeCollectionDate.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.string),
  onBackClick: PropTypes.func,
  ...ReduxFormPropTypes,
};

export default compose(
  loadActionDates,
  withCollectionEdit({
    onSubmit: onChangeCollectionDateSubmit,
    validate: collectEditValidators.changeCollectionDateValidator,
  }),
  withTrack(CHANGE_COLLECTION_DATE_COMPONENT.LOAD),
  withTrackProps({
    onBackClick: () => CHANGE_COLLECTION_DATE_COMPONENT.CLICK_BACK,
    onSubmit: () => CHANGE_COLLECTION_DATE_COMPONENT.CLICK_SUBMIT,
    onInputFocus: fieldName => {
      switch (fieldName) {
        case "sms":
          return CHANGE_COLLECTION_DATE_COMPONENT.CLICK_SMS;
        case "email":
          return CHANGE_COLLECTION_DATE_COMPONENT.CLICK_EMAIL;
        case "contactName":
          return CHANGE_COLLECTION_DATE_COMPONENT.CLICK_CONTACT_NAME;
        case "collectionDate":
          return CHANGE_COLLECTION_DATE_COMPONENT.CLICK_DATE;
        case "instructions":
          return CHANGE_COLLECTION_DATE_COMPONENT.CLICK_INSTRUCTIONS;
        default:
          break;
      }
    },
  }),
  hadleInputFocus
)(ChangeCollectionDate);
